import utils from './utils.js';
//import init from './init.js';
import app from './app.js';

const MIN_SIZE = 50
export const Crop = function(parent, containerId, CropBoxId, target) {
    this.status = 0
    this.parent = parent
    this.containerId = containerId
    this.container = ''
    this.cropBoxId = CropBoxId
    this.cropBox = ''
    this.cropTarget = target
    this.cropBoxXScale = 1
    this.cropBoxYScale = 1
    this.cropBoxTopscale = 0
    this.cropBoxLeftScale = 0
    this.cropRatio = 0
    this.border = '4px solid #000;'

    this.init()
}

Crop.prototype.init = function() {

    let _this = this
    this.createCropBox(this.createContainer())
    
    let startDrag = function (point, target, kind) {
        if (utils.browserIsPc()) {
            _this.mouseDrag(point, target, kind)
        } else {
            _this.touchDrag(point, target, kind)
        }
    };

    //绑定拖拽
    startDrag(utils.ID("zxxDragBg"), utils.ID("zxxCropBox"), "drag");
    //绑定拉伸
    startDrag(utils.ID("dragLeftTop"), utils.ID("zxxCropBox"), "nw");
    startDrag(utils.ID("dragLeftBot"), utils.ID("zxxCropBox"), "sw");
    startDrag(utils.ID("dragRightTop"), utils.ID("zxxCropBox"), "ne");
    startDrag(utils.ID("dragRightBot"), utils.ID("zxxCropBox"), "se");
    startDrag(utils.ID("dragTopCenter"), utils.ID("zxxCropBox"), "n");
    startDrag(utils.ID("dragBotCenter"), utils.ID("zxxCropBox"), "s");
    startDrag(utils.ID("dragRightCenter"), utils.ID("zxxCropBox"), "e");
    startDrag(utils.ID("dragLeftCenter"), utils.ID("zxxCropBox"), "w");
}

Crop.prototype.show = function() {
    //this.updateContainerSize()
    this.container.style.display = 'block'
    //this.updateCropBoxSize()
}

Crop.prototype.hide = function() {
    this.container.style.display = 'none'
}

Crop.prototype.destroy = function() {
    this.container.remove()
    app.crop = null
}

Crop.prototype.showBorderDragPoint = function() {
    document.querySelector('#dragTopCenter').style.display = 'block'
    document.querySelector('#dragBotCenter').style.display = 'block'
    document.querySelector('#dragRightCenter').style.display = 'block'
    document.querySelector('#dragLeftCenter').style.display = 'block'
}

Crop.prototype.hideBorderDragPoint = function() {
    document.querySelector('#dragTopCenter').style.display = 'none'
    document.querySelector('#dragBotCenter').style.display = 'none'
    document.querySelector('#dragRightCenter').style.display = 'none'
    document.querySelector('#dragLeftCenter').style.display = 'none'
}

Crop.prototype.setRatio = function(val) {
    this.cropRatio = val
    this.updateCropBoxSize()
    if (val != 0) {
        this.hideBorderDragPoint()
    } else {
        this.showBorderDragPoint()
    }
    app.cropRecord.addObject({
        type: 'crop',
        width: parseFloat(this.cropBox.offsetWidth),
        height: parseFloat(this.cropBox.offsetHeight),
        top: parseFloat(this.cropBox.offsetTop),
        left: parseFloat(this.cropBox.offsetLeft),
    })
}

Crop.prototype.updateCropBoxSize = function() {
    if (this.cropRatio == 0) {
        this.cropBox.style.width = this.container.offsetWidth + 'px' 
        this.cropBox.style.height = this.container.offsetHeight + 'px'
        this.cropBox.style.top = 0
        this.cropBox.style.left = 0
    } else if (this.cropRatio > 1) {
        let calcHeight = this.container.offsetWidth / this.cropRatio
        if (calcHeight <= this.container.offsetHeight) {
            this.cropBox.style.width = this.container.offsetWidth + 'px' 
            this.cropBox.style.height = this.container.offsetWidth / this.cropRatio + 'px'
            this.cropBox.style.top =  (this.container.offsetHeight - this.cropBox.offsetHeight) / 2 + 'px'
            this.cropBox.style.left =  0
        } else {
            this.cropBox.style.height = this.container.offsetHeight + 'px'
            this.cropBox.style.width = this.container.offsetHeight * this.cropRatio + 'px' 
            this.cropBox.style.left =  (this.container.offsetWidth - this.cropBox.offsetWidth) / 2 + 'px'
            this.cropBox.style.top =  0
        }
    } else if (this.cropRatio < 1) {
        let calcWidth = this.container.offsetHeight * this.cropRatio
        if (calcWidth <= this.container.offsetWidth) {
            this.cropBox.style.height = this.container.offsetHeight + 'px'
            this.cropBox.style.width = this.container.offsetHeight * this.cropRatio + 'px' 
            this.cropBox.style.left =  (this.container.offsetWidth - this.cropBox.offsetWidth) / 2 + 'px'
            this.cropBox.style.top =  0
        } else {
            this.cropBox.style.width = this.container.offsetWidth + 'px' 
            this.cropBox.style.height = this.container.offsetWidth / this.cropRatio + 'px'
            this.cropBox.style.top =  (this.container.offsetHeight - this.cropBox.offsetHeight) / 2 + 'px'
            this.cropBox.style.left =  0
        }
    } else {
        this.cropBox.style.height = this.cropBox.style.width = Math.min(this.container.offsetHeight, this.container.offsetWidth) + 'px'
        this.cropBox.style.top =  (this.container.offsetHeight - this.cropBox.offsetHeight) / 2 + 'px'
        this.cropBox.style.left =  (this.container.offsetWidth - this.cropBox.offsetWidth) / 2 + 'px'
    }
    this.cropBoxXScale = this.cropBox.offsetWidth / this.container.offsetWidth
    this.cropBoxYScale = this.cropBox.offsetHeight / this.container.offsetHeight
    this.cropBoxTopscale = this.cropBox.offsetTop / this.container.offsetHeight
    this.cropBoxLeftScale = this.cropBox.offsetLeft / this.container.offsetWidth
    app.model.updateCropCover()
}

Crop.prototype.createContainer = function() {
    let oRelDiv = document.createElement("div")
    oRelDiv.style.position = "absolute"
    oRelDiv.style.zIndex = 50
    oRelDiv.style.overflow = 'hidden'
    oRelDiv.style.transform = 'translate(-50%, -50%)'
    oRelDiv.id = this.containerId
    this.container = oRelDiv

    this.parent.appendChild(oRelDiv)
    this.updateContainerSize()
    return oRelDiv
}

Crop.prototype.createCropBox = function(oRelDiv) {
    let html =  '<div id="'+this.cropBoxId+'" style="width: 100%;height: 100%;position:absolute; z-index:10;">' +
        '<div id="zxxDragBg" style="height:100%; cursor:move;border: 1px dashed #dedede;box-sizing: border-box;"></div>' +
        '<div id="dragLeftTop" class="drag-block" style="width:15px; height:15px;  border-top:'+this.border+'border-left:'+this.border+'left:0px; top:0px; cursor:nw-resize;"></div>' +
        '<div id="dragLeftBot" class="drag-block" style="width:15px; height:15px; border-bottom:'+this.border+'border-left:'+this.border+'left:0px; bottom:0px; cursor:sw-resize;"></div>' +
        '<div id="dragRightTop" class="drag-block" style="width:15px; height:15px; border-top:'+this.border+'border-right:'+this.border+'right:0px; top:0px; cursor:ne-resize;"></div>' +
        '<div id="dragRightBot" class="drag-block" style="width:15px; height:15px; border-bottom:'+this.border+'border-right:'+this.border+'right:0px; bottom:0px; cursor:se-resize;"></div>' +
        '<div id="dragTopCenter" class="drag-block" style="width:20px; height:0px; border-top:'+this.border+'top:0px; left:50%; margin-left:-10px; cursor:n-resize;"></div>' +
        '<div id="dragBotCenter" class="drag-block" style="width:20px; height:0px; border-bottom:'+this.border+'bottom:0px; left:50%; margin-left:-10px; cursor:s-resize;"></div>' +
        '<div id="dragRightCenter" class="drag-block" style="width:0px; height:20px; border-right:'+this.border+'right:0px; top:50%; margin-top:-10px; cursor:e-resize;"></div> ' +
        '<div id="dragLeftCenter" class="drag-block" style="width:0px; height:20px; border-left:'+this.border+'left:0px; top:50%; margin-top:-10px; cursor:w-resize;"></div>' +
        '</div>'
    oRelDiv.innerHTML = html;
    this.cropBox = document.querySelector('#'+this.cropBoxId)
    document.querySelectorAll('.drag-block').forEach( item => {
        item.style.position = 'absolute'
        item.style.opacity = 0.7
        item.style.overflow = 'hidden'
    })
    return html
}

Crop.prototype.updateContainerSize = function() {
    this.container.style.width = this.cropTarget.offsetWidth + 'px'
    this.container.style.height = this.cropTarget.offsetHeight + 'px'
    this.container.style.top = this.cropTarget.offsetTop + 'px'
    this.container.style.left = this.cropTarget.offsetLeft + 'px'
}

/**
 * 鼠标移动事件
 */
Crop.prototype.mouseDrag = function(point, target, kind) {
    let _this = this
    point.onmousedown = function (event) {
        //初始化宽高
        params.width = utils.getCss(target, "width");
        params.height = utils.getCss(target, "height");

        //初始化坐标
        if (utils.getCss(target, "left") !== "auto") {
            params.left = utils.getCss(target, "left");
        }
        if (utils.getCss(target, "top") !== "auto") {
            params.top = utils.getCss(target, "top");
        }
        params.kind = kind;
        params.flag = true;

        if (!event) {
            event = window.event;
        }
        var e = event;
        params.currentX = e.clientX;
        params.currentY = e.clientY;

        var startX = e.clientX - target.offsetLeft;  
        var startY = e.clientY - target.offsetTop;  
        
        //防止IE文字选中，有助于拖拽平滑
        point.onselectstart = function() {
            return false;
        };
        document.onmousemove = function (event) {
            let e = event ? event : window.event;
            if (params.flag) {
                var nowX = e.clientX, 
                    nowY = e.clientY,
                    disX = nowX - params.currentX, 
                    disY = nowY - params.currentY;

                if (params.kind === "n") {//上拉伸, 高度增加或减小，位置上下移动
                    if (parseInt(params.height) - disY >= MIN_SIZE && parseInt(params.top) + disY >= 0) {
                        target.style.height = parseInt(params.height) - disY + "px";
                        target.style.top = parseInt(params.top) + disY + "px";
                    } else if ( parseInt(params.top) + disY < 0) {
                        target.style.top = 0 + "px";
                        target.style.height = parseInt(params.height) + parseInt(params.top) + "px";
                    }
                } else if (params.kind === "s") {//下拉伸
                    if (parseInt(params.height) + disY >= MIN_SIZE 
                        && parseInt(params.height) + disY + parseInt(params.top) <= _this.container.offsetHeight) {
                        target.style.height = parseInt(params.height) + disY + "px";
                    } else if (parseInt(params.height) + disY + parseInt(params.top) > _this.container.offsetHeight) {
                        target.style.height = _this.container.offsetHeight - parseInt(params.top) + "px";
                    }
                } else if (params.kind === "w") {//左拉伸
                    if (parseInt(params.width) - disX >= MIN_SIZE) {
                        target.style.left = parseInt(params.left) + disX + "px";
                        target.style.width = parseInt(params.width) - disX + "px";
                        if (parseInt(params.left) + disX < 0) {
                            target.style.left = 0 + "px";
                            target.style.width = parseInt(params.width) + parseInt(params.left) + "px";
                        }
                    }
                } else if (params.kind === "e") {//右拉伸
                    if (parseInt(params.width) + disX >= MIN_SIZE) {
                        target.style.width = parseInt(params.width) + disX + "px";
                        if (parseInt(params.width) + parseInt(params.left) + disX > _this.container.offsetWidth) {
                            target.style.width = _this.container.offsetWidth - parseInt(params.left) + "px";
                        }
                    }
                } else if (params.kind === "nw") {//左上拉伸
                    let changeWidth = parseInt(params.width) - disX,
                        changeHeight = parseInt(params.height) - disY

                    // 定比例拉伸以上拉伸为主
                    if (_this.cropRatio > 0) {

                        disX = _this.cropRatio * disY 

                        let changeWidth = parseInt(params.width) - disX,
                            changeHeight = parseInt(params.height) - disY,
                            changeTop = parseInt(params.top) + disY,
                            changeLeft = parseInt(params.left) + disX;

                        if (changeWidth >= MIN_SIZE && changeHeight >= MIN_SIZE && changeTop >= 0 && changeLeft >= 0) {
                            target.style.width = changeWidth + "px";
                            target.style.left = changeLeft + "px";
                            target.style.height = changeHeight + "px";
                            target.style.top = changeTop + "px";
                        }

                        
                        /*if (parseInt(params.top) + disY < 0) {
                            return false
                        }
                        if (parseInt(params.left) + disX < 0) {
                            return false
                        }
                        
                        target.style.height = parseInt(params.height) - disY + "px";
                        target.style.top = parseInt(params.top) + disY + "px";
                        target.style.left = parseInt(params.left) + disX + "px";*/
                    } else {
                        if (changeWidth >= MIN_SIZE) {
                            target.style.width = parseInt(params.width) - disX + "px";
                            target.style.left = parseInt(params.left) + disX + "px";
                            if (parseInt(params.left) + disX < 0) {
                                target.style.left = 0 + "px";
                                target.style.width = parseInt(params.width) + parseInt(params.left) + "px";
                            }
                        }
                        if (changeHeight >= MIN_SIZE) {
                            target.style.height = parseInt(params.height) - disY + "px";
                            target.style.top = parseInt(params.top) + disY + "px";
                            
                            if (parseInt(params.top) + disY < 0) {
                                target.style.top = 0 + "px";
                                target.style.height = parseInt(params.height) + parseInt(params.top) + "px";
                            }
                        }
                    }
                } else if (params.kind === "ne") {//右上拉伸

                    let changeWidth = parseInt(params.width) + disX,
                        changeHeight = parseInt(params.height) - disY

                    // 定比例拉伸以上拉伸为主
                    if (_this.cropRatio > 0) {
                        disX = -_this.cropRatio * disY
                        let changeWidth = parseInt(params.width) + disX,
                            changeHeight = parseInt(params.height) - disY,
                            changeTop = parseInt(params.top) + disY;

                        if (changeWidth >= MIN_SIZE && changeHeight >= MIN_SIZE && changeTop >= 0 && changeWidth + parseInt(params.left) <= _this.container.offsetWidth) {
                            target.style.top = changeTop + "px";
                            target.style.height = changeHeight + "px";
                            target.style.width = changeWidth + "px";
                        } 

                        /*if (parseInt(params.top) + disY < 0 && parseInt(params.width) + parseInt(params.left) + disX > _this.container.offsetWidth) {
                            target.style.top = 0;
                            target.style.height = parseInt(params.height) + parseInt(params.top) + "px";
                            target.style.width = parseInt(params.width) + disX + "px";
                            return false
                        }
                        if (parseInt(params.width) + parseInt(params.left) + disX > _this.container.offsetWidth) {
                            return false
                        }
                        target.style.top = parseInt(params.top) + disY + "px";
                        target.style.height = parseInt(params.height) - disY + "px";
                        target.style.width = parseInt(params.width) + disX + "px";*/
                    } else {

                        if (changeWidth >= MIN_SIZE) {
                            target.style.width = parseInt(params.width) + disX + "px";
                            if (parseInt(params.width) + parseInt(params.left) + disX > _this.container.offsetWidth) {
                                target.style.width = _this.container.offsetWidth - parseInt(params.left) + "px";
                            }
                        }
                        if (changeHeight >= MIN_SIZE) {
                            target.style.top = parseInt(params.top) + disY + "px";
                            target.style.height = parseInt(params.height) - disY + "px";
                            
                            if (parseInt(params.top) + disY < 0) {
                                target.style.top = 0 + "px";
                                target.style.height = parseInt(params.height) + parseInt(params.top) + "px";
                            }
                        }
                    }
                } else if (params.kind === "sw") {//左下拉伸

                    let changeWidth = parseInt(params.width) - disX,
                        changeHeight = parseInt(params.height) + disY

                    // 定比例拉伸以下拉伸为主
                    if (_this.cropRatio > 0) {
                        disX = -_this.cropRatio * disY 

                        let changeWidth = parseInt(params.width) - disX,
                            changeHeight = parseInt(params.height) + disY,
                            changeLeft = parseInt(params.left) + disX;

                        if (changeWidth >= MIN_SIZE && changeHeight >= MIN_SIZE && changeLeft >= 0) {
                            target.style.left = changeLeft + "px";
                            target.style.width = changeWidth + "px";
                            target.style.height = changeHeight + "px";
                        }

                        /*if (parseInt(params.left) + disX < 0) {
                            return false
                        }
                        if (parseInt(params.height) + parseInt(params.top) + disY > _this.container.offsetHeight) {
                            return false
                        }
                        target.style.left = parseInt(params.left) + disX + "px";
                        target.style.width = parseInt(params.width) - disX + "px";
                        target.style.height = parseInt(params.height) + disY + "px";*/
                    } else {

                        if (changeWidth >= MIN_SIZE) {
                            target.style.width = parseInt(params.width) - disX + "px";
                            target.style.left = parseInt(params.left) + disX + "px";

                            if (parseInt(params.left) + disX < 0) {
                                target.style.left = 0 + "px";
                                target.style.width = parseInt(params.width) + parseInt(params.left) + "px";
                            }
                        }

                        if (changeHeight >= MIN_SIZE) {
                            target.style.height = parseInt(params.height) + disY + "px";
                            if (parseInt(params.height) + parseInt(params.top) + disY > _this.container.offsetHeight) {
                                target.style.height = _this.container.offsetHeight - parseInt(params.top) + "px";
                            }
                        }
                    }
                } else if (params.kind === "se") {//右下拉伸

                    let changeWidth = parseInt(params.width) + disX,
                        changeHeight = parseInt(params.height) + disY

                    // 定比例拉伸以下拉伸为主
                    if (_this.cropRatio > 0) {
                        disX = _this.cropRatio * disY 

                        let changeWidth = parseInt(params.width) + disX,
                            changeHeight = parseInt(params.height) + disY;

                        if (changeWidth >= MIN_SIZE 
                            && changeHeight >= MIN_SIZE 
                            && changeWidth + parseInt(params.left) <=  _this.container.offsetWidth
                            && changeHeight + parseInt(params.top) <= _this.container.offsetHeight ) {
                            target.style.width = changeWidth+ "px";
                            target.style.height = changeHeight + "px";
                        }

                        /*if (parseInt(params.width) + parseInt(params.left) + disX > _this.container.offsetWidth) {
                            return false
                        }
                        if (parseInt(params.height) + parseInt(params.top) + disY > _this.container.offsetHeight) {
                            return false
                        }
                        target.style.width = parseInt(params.width) + disX + "px";
                        target.style.height = parseInt(params.height) + disY + "px";*/
                    } else {

                        if (changeWidth >= MIN_SIZE) {
                            target.style.width = parseInt(params.width) + disX + "px";
                            if (parseInt(params.width) + parseInt(params.left) + disX > _this.container.offsetWidth) {
                                target.style.width = _this.container.offsetWidth - parseInt(params.left) + "px";
                            }
                        }

                        if (changeHeight >= MIN_SIZE) {
                            target.style.height = parseInt(params.height) + disY + "px";
                            if (parseInt(params.height) + parseInt(params.top) + disY > _this.container.offsetHeight) {
                                target.style.height = _this.container.offsetHeight - parseInt(params.top) + "px";
                            }
                        }
                    }
                } else {//移动
                    target.style.left = parseInt(params.left) + disX + "px";
                    target.style.top = parseInt(params.top) + disY + "px";
                    // 上边界
                    if (parseInt(target.style.top) < 0) {
                        target.style.top = 0
                    }
                    // 左边界
                    if (parseInt(target.style.left) < 0) {
                        target.style.left = 0
                    }
                    // 下边界
                    if (parseInt(target.style.top) + target.offsetHeight >  _this.container.offsetHeight) {
                        target.style.top = _this.container.offsetHeight - target.offsetHeight + 'px'
                    }
                    // 右边界
                    if (parseInt(target.style.left) + target.offsetWidth >  _this.container.offsetWidth) {
                        target.style.left = _this.container.offsetWidth - target.offsetWidth + 'px'
                    }
                }
                
                app.model.updateCropCover()
            }
        }
        document.onmouseup = function () {
            params.flag = false;
            if (utils.getCss(target, "left") !== "auto") {
                params.left = utils.getCss(target, "left");
            }
            if (utils.getCss(target, "top") !== "auto") {
                params.top = utils.getCss(target, "top");
            }
            params.width = utils.getCss(target, "width");
            params.height = utils.getCss(target, "height");

            _this.cropBoxXScale = parseInt(params.width) / _this.container.offsetWidth
            _this.cropBoxYScale = parseInt(params.height) / _this.container.offsetHeight
            _this.cropBoxTopscale = parseInt(params.top) / _this.container.offsetHeight
            _this.cropBoxLeftScale = parseInt(params.left) / _this.container.offsetWidth

            document.onmousemove = null
            document.onmouseup = null

            app.cropRecord.addObject({
                type: 'crop',
                width: parseFloat(params.width),
                height: parseFloat(params.height),
                top: parseFloat(params.top),
                left: parseFloat(params.left),
            })
        };
    };
}

Crop.prototype.makeCrop = function() {
    let canvas = document.createElement('canvas'),
        ctx = canvas.getContext('2d'),
        _this = this

    canvas.width = this.cropBox.offsetWidth / app.zoom.scaling
    canvas.height = this.cropBox.offsetHeight / app.zoom.scaling
    ctx.drawImage(app.uploadFile.image,
                  this.cropBox.offsetLeft / app.zoom.scaling,
                  this.cropBox.offsetTop / app.zoom.scaling,
                  this.cropBox.offsetWidth / app.zoom.scaling,
                  this.cropBox.offsetHeight / app.zoom.scaling,
                  0, 0, canvas.width, canvas.height)
    return {
        canvas:canvas,
        crop:[
            this.cropBox.offsetLeft / app.zoom.scaling,
            this.cropBox.offsetTop / app.zoom.scaling,
            this.cropBox.offsetWidth / app.zoom.scaling,
            this.cropBox.offsetHeight / app.zoom.scaling,
        ]
    }
}



/**
 * 触摸移动事件
 */
Crop.prototype.touchDrag = function(point, target, kind) {
    let _this = this
    point.ontouchstart = function (event) {
        event.preventDefault();
        //初始化宽高
        params.width = utils.getCss(target, "width");
        params.height = utils.getCss(target, "height");

        //初始化坐标
        if (utils.getCss(target, "left") !== "auto") {
            params.left = utils.getCss(target, "left");
        }
        if (utils.getCss(target, "top") !== "auto") {
            params.top = utils.getCss(target, "top");
        }
        params.kind = kind;
        params.flag = true;

        if (!event) {
            event = window.event;
        }
        var e = event;
        params.currentX = e.changedTouches[0].pageX;
        params.currentY = e.changedTouches[0].pageY;

        var startX = e.changedTouches[0].pageX - target.offsetLeft;  
        var startY = e.changedTouches[0].pageY - target.offsetTop;  
        
        //防止IE文字选中，有助于拖拽平滑
        point.onselectstart = function() {
            return false;
        };
        document.ontouchmove = function (event) {
            let e = event ? event : window.event;
            e.preventDefault();
            if (params.flag) {
                var nowX = e.changedTouches[0].pageX, 
                    nowY = e.changedTouches[0].pageY,
                    disX = nowX - params.currentX, 
                    disY = nowY - params.currentY;

                if (params.kind === "n") {//上拉伸, 高度增加或减小，位置上下移动
                    if (parseInt(params.height) - disY >= MIN_SIZE && parseInt(params.top) + disY >= 0) {
                        target.style.height = parseInt(params.height) - disY + "px";
                        target.style.top = parseInt(params.top) + disY + "px";
                    } else if ( parseInt(params.top) + disY < 0) {
                        target.style.top = 0 + "px";
                        target.style.height = parseInt(params.height) + parseInt(params.top) + "px";
                    }
                } else if (params.kind === "s") {//下拉伸
                    if (parseInt(params.height) + disY >= MIN_SIZE 
                        && parseInt(params.height) + disY + parseInt(params.top) <= _this.container.offsetHeight) {
                        target.style.height = parseInt(params.height) + disY + "px";
                    } else if (parseInt(params.height) + disY + parseInt(params.top) > _this.container.offsetHeight) {
                        target.style.height = _this.container.offsetHeight - parseInt(params.top) + "px";
                    }
                } else if (params.kind === "w") {//左拉伸
                    if (parseInt(params.width) - disX >= MIN_SIZE) {
                        target.style.left = parseInt(params.left) + disX + "px";
                        target.style.width = parseInt(params.width) - disX + "px";
                        if (parseInt(params.left) + disX < 0) {
                            target.style.left = 0 + "px";
                            target.style.width = parseInt(params.width) + parseInt(params.left) + "px";
                        }
                    }
                } else if (params.kind === "e") {//右拉伸
                    if (parseInt(params.width) + disX >= MIN_SIZE) {
                        target.style.width = parseInt(params.width) + disX + "px";
                        if (parseInt(params.width) + parseInt(params.left) + disX > _this.container.offsetWidth) {
                            target.style.width = _this.container.offsetWidth - parseInt(params.left) + "px";
                        }
                    }
                } else if (params.kind === "nw") {//左上拉伸
                    let changeWidth = parseInt(params.width) - disX,
                        changeHeight = parseInt(params.height) - disY

                    // 定比例拉伸以上拉伸为主
                    if (_this.cropRatio > 0) {

                        disX = _this.cropRatio * disY 

                        let changeWidth = parseInt(params.width) - disX,
                            changeHeight = parseInt(params.height) - disY,
                            changeTop = parseInt(params.top) + disY,
                            changeLeft = parseInt(params.left) + disX;

                        if (changeWidth >= MIN_SIZE && changeHeight >= MIN_SIZE && changeTop >= 0 && changeLeft >= 0) {
                            target.style.width = changeWidth + "px";
                            target.style.left = changeLeft + "px";
                            target.style.height = changeHeight + "px";
                            target.style.top = changeTop + "px";
                        }

                        
                        /*if (parseInt(params.top) + disY < 0) {
                            return false
                        }
                        if (parseInt(params.left) + disX < 0) {
                            return false
                        }
                        
                        target.style.height = parseInt(params.height) - disY + "px";
                        target.style.top = parseInt(params.top) + disY + "px";
                        target.style.left = parseInt(params.left) + disX + "px";*/
                    } else {
                        if (changeWidth >= MIN_SIZE) {
                            target.style.width = parseInt(params.width) - disX + "px";
                            target.style.left = parseInt(params.left) + disX + "px";
                            if (parseInt(params.left) + disX < 0) {
                                target.style.left = 0 + "px";
                                target.style.width = parseInt(params.width) + parseInt(params.left) + "px";
                            }
                        }
                        if (changeHeight >= MIN_SIZE) {
                            target.style.height = parseInt(params.height) - disY + "px";
                            target.style.top = parseInt(params.top) + disY + "px";
                            
                            if (parseInt(params.top) + disY < 0) {
                                target.style.top = 0 + "px";
                                target.style.height = parseInt(params.height) + parseInt(params.top) + "px";
                            }
                        }
                    }
                } else if (params.kind === "ne") {//右上拉伸

                    let changeWidth = parseInt(params.width) + disX,
                        changeHeight = parseInt(params.height) - disY

                    // 定比例拉伸以上拉伸为主
                    if (_this.cropRatio > 0) {
                        disX = -_this.cropRatio * disY
                        let changeWidth = parseInt(params.width) + disX,
                            changeHeight = parseInt(params.height) - disY,
                            changeTop = parseInt(params.top) + disY;

                        if (changeWidth >= MIN_SIZE && changeHeight >= MIN_SIZE && changeTop >= 0 && changeWidth + parseInt(params.left) <= _this.container.offsetWidth) {
                            target.style.top = changeTop + "px";
                            target.style.height = changeHeight + "px";
                            target.style.width = changeWidth + "px";
                        } 

                        /*if (parseInt(params.top) + disY < 0 && parseInt(params.width) + parseInt(params.left) + disX > _this.container.offsetWidth) {
                            target.style.top = 0;
                            target.style.height = parseInt(params.height) + parseInt(params.top) + "px";
                            target.style.width = parseInt(params.width) + disX + "px";
                            return false
                        }
                        if (parseInt(params.width) + parseInt(params.left) + disX > _this.container.offsetWidth) {
                            return false
                        }
                        target.style.top = parseInt(params.top) + disY + "px";
                        target.style.height = parseInt(params.height) - disY + "px";
                        target.style.width = parseInt(params.width) + disX + "px";*/
                    } else {

                        if (changeWidth >= MIN_SIZE) {
                            target.style.width = parseInt(params.width) + disX + "px";
                            if (parseInt(params.width) + parseInt(params.left) + disX > _this.container.offsetWidth) {
                                target.style.width = _this.container.offsetWidth - parseInt(params.left) + "px";
                            }
                        }
                        if (changeHeight >= MIN_SIZE) {
                            target.style.top = parseInt(params.top) + disY + "px";
                            target.style.height = parseInt(params.height) - disY + "px";
                            
                            if (parseInt(params.top) + disY < 0) {
                                target.style.top = 0 + "px";
                                target.style.height = parseInt(params.height) + parseInt(params.top) + "px";
                            }
                        }
                    }
                } else if (params.kind === "sw") {//左下拉伸

                    let changeWidth = parseInt(params.width) - disX,
                        changeHeight = parseInt(params.height) + disY

                    // 定比例拉伸以下拉伸为主
                    if (_this.cropRatio > 0) {
                        disX = -_this.cropRatio * disY 

                        let changeWidth = parseInt(params.width) - disX,
                            changeHeight = parseInt(params.height) + disY,
                            changeLeft = parseInt(params.left) + disX;

                        if (changeWidth >= MIN_SIZE && changeHeight >= MIN_SIZE && changeLeft >= 0) {
                            target.style.left = changeLeft + "px";
                            target.style.width = changeWidth + "px";
                            target.style.height = changeHeight + "px";
                        }

                        /*if (parseInt(params.left) + disX < 0) {
                            return false
                        }
                        if (parseInt(params.height) + parseInt(params.top) + disY > _this.container.offsetHeight) {
                            return false
                        }
                        target.style.left = parseInt(params.left) + disX + "px";
                        target.style.width = parseInt(params.width) - disX + "px";
                        target.style.height = parseInt(params.height) + disY + "px";*/
                    } else {

                        if (changeWidth >= MIN_SIZE) {
                            target.style.width = parseInt(params.width) - disX + "px";
                            target.style.left = parseInt(params.left) + disX + "px";

                            if (parseInt(params.left) + disX < 0) {
                                target.style.left = 0 + "px";
                                target.style.width = parseInt(params.width) + parseInt(params.left) + "px";
                            }
                        }

                        if (changeHeight >= MIN_SIZE) {
                            target.style.height = parseInt(params.height) + disY + "px";
                            if (parseInt(params.height) + parseInt(params.top) + disY > _this.container.offsetHeight) {
                                target.style.height = _this.container.offsetHeight - parseInt(params.top) + "px";
                            }
                        }
                    }
                } else if (params.kind === "se") {//右下拉伸

                    let changeWidth = parseInt(params.width) + disX,
                        changeHeight = parseInt(params.height) + disY

                    // 定比例拉伸以下拉伸为主
                    if (_this.cropRatio > 0) {
                        disX = _this.cropRatio * disY 

                        let changeWidth = parseInt(params.width) + disX,
                            changeHeight = parseInt(params.height) + disY;

                        if (changeWidth >= MIN_SIZE 
                            && changeHeight >= MIN_SIZE 
                            && changeWidth + parseInt(params.left) <=  _this.container.offsetWidth
                            && changeHeight + parseInt(params.top) <= _this.container.offsetHeight ) {
                            target.style.width = changeWidth+ "px";
                            target.style.height = changeHeight + "px";
                        }

                        /*if (parseInt(params.width) + parseInt(params.left) + disX > _this.container.offsetWidth) {
                            return false
                        }
                        if (parseInt(params.height) + parseInt(params.top) + disY > _this.container.offsetHeight) {
                            return false
                        }
                        target.style.width = parseInt(params.width) + disX + "px";
                        target.style.height = parseInt(params.height) + disY + "px";*/
                    } else {

                        if (changeWidth >= MIN_SIZE) {
                            target.style.width = parseInt(params.width) + disX + "px";
                            if (parseInt(params.width) + parseInt(params.left) + disX > _this.container.offsetWidth) {
                                target.style.width = _this.container.offsetWidth - parseInt(params.left) + "px";
                            }
                        }

                        if (changeHeight >= MIN_SIZE) {
                            target.style.height = parseInt(params.height) + disY + "px";
                            if (parseInt(params.height) + parseInt(params.top) + disY > _this.container.offsetHeight) {
                                target.style.height = _this.container.offsetHeight - parseInt(params.top) + "px";
                            }
                        }
                    }
                } else {//移动
                    target.style.left = parseInt(params.left) + disX + "px";
                    target.style.top = parseInt(params.top) + disY + "px";
                    // 上边界
                    if (parseInt(target.style.top) < 0) {
                        target.style.top = 0
                    }
                    // 左边界
                    if (parseInt(target.style.left) < 0) {
                        target.style.left = 0
                    }
                    // 下边界
                    if (parseInt(target.style.top) + target.offsetHeight >  _this.container.offsetHeight) {
                        target.style.top = _this.container.offsetHeight - target.offsetHeight + 'px'
                    }
                    // 右边界
                    if (parseInt(target.style.left) + target.offsetWidth >  _this.container.offsetWidth) {
                        target.style.left = _this.container.offsetWidth - target.offsetWidth + 'px'
                    }
                }
                
                app.model.updateCropCover()
            }
        }
        document.ontouchend = function () {
            params.flag = false;
            if (utils.getCss(target, "left") !== "auto") {
                params.left = utils.getCss(target, "left");
            }
            if (utils.getCss(target, "top") !== "auto") {
                params.top = utils.getCss(target, "top");
            }
            params.width = utils.getCss(target, "width");
            params.height = utils.getCss(target, "height");

            _this.cropBoxXScale = parseInt(params.width) / _this.container.offsetWidth
            _this.cropBoxYScale = parseInt(params.height) / _this.container.offsetHeight
            _this.cropBoxTopscale = parseInt(params.top) / _this.container.offsetHeight
            _this.cropBoxLeftScale = parseInt(params.left) / _this.container.offsetWidth

            document.ontouchmove = null
            document.ontouchend = null
            app.cropRecord.addObject({
                type: 'crop',
                width: parseFloat(params.width),
                height: parseFloat(params.height),
                top: parseFloat(params.top),
                left: parseFloat(params.left),
            })
        };
    };
}


let params = {
    left: 0,
    top: 0,
    width: 0,
    height: 0,
    currentX: 0,
    currentY: 0,
    flag: false,
    kind: "drag"
};

